export default "__VITE_ASSET__Be6o22cK__"